import cn from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './Result.module.scss';

type ResultProps = {
  className?: string;
  text?: string | JSX.Element;
  textClassName?: string;
  icon?: ReactNode;
  extra?: ReactNode;
};

export const Result: FC<ResultProps> = (props) => {
  const { className, text, icon, extra, textClassName } = props;

  return (
    <div className={cn(styles.container, className)}>
      {icon && <div className={styles.icon}>{icon}</div>}
      {text && <p className={cn(styles.text, textClassName, 'p2')}>{text}</p>}
      {extra && <div className={styles.extra}>{extra}</div>}
    </div>
  );
};
